<template>
    <div class="container">
        <h2>Submittal Document Preview</h2>
        <p>We are now generating your submittal. Large submittals will take longer to generate than smaller ones.</p>
    </div>

</template>

<script>
    export default {
        props: ['project']
    }
</script>